


















import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import helpers from '@/shared/service/helper'

@Component({
    name: 'ldw-side-nav'
})

export default class SideNavigationComponent extends Vue {
    // data
    // methods
    public async findSeparatorComponent(component: string) {
        if (this.$router.currentRoute.name === component || this.$router.currentRoute.name === 'start') {
            const anchorComponent: any = this.$parent.$children.find((ref) => Object.keys(ref.$refs)[0] === component)
            helpers.scrollToComponent(anchorComponent.$el)
            this.closeSideNavigation()
        } else {
            await this.$router.push('/#' + component)
            if (this.$store.getters.sideNavigationState === true) {
                this.closeSideNavigation()
            }
        }
    }

    public closeSideNavigation() {
        setTimeout(() => {
            this.$store.dispatch('changeSideNavigationState', false)
        }, 100)
    }
}
